import type { AccountProgram } from "../model/AccountProgram";
import API, { responseOf } from "./base";

export const create = (program: AccountProgram): Promise<AccountProgram> =>
  responseOf(API.post("/account-programs", program));

export const get = (accountProgramId: string): Promise<AccountProgram> =>
  responseOf(API.get(`/account-programs/${accountProgramId}`));

export const update = (
  accountProgram: AccountProgram,
): Promise<AccountProgram> =>
  responseOf(API.put(`/account-programs/${accountProgram.id}`, accountProgram));

export const remove = async (accountProgramId: string): Promise<void> => {
  await API.delete(`/account-programs/${accountProgramId}`);
};

export const loadByAccountId = (accountId: string): Promise<AccountProgram[]> =>
  responseOf(API.get(`/account-programs/load/${accountId}`));
